import contact from './contact.vue'

export default contact
